module.exports =
  '_PASSWORD':
    'NEW':
      'TITLE': 'Forgot Password'
      'EMAIL_ADDR': 'Email Address'
      'SUCCESS': 'You will receive an email with instructions about how to reset your password in a few minutes.'
      'ERROR': 'Your email address was not found.'
      'PAGE_TITLE': 'Forgot your password? Please enter your email address.'
    'EDIT':
      'TITLE': 'Reset Password'
      'PAGE_TITLE': 'Enter your new password.'
      'NEW_PASSWORD': 'New Password'
      'CONFIRM_PASSWORD': 'Confirm Password'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/password/i18n/en.coffee